<i class="{{class}}" [attr.data-feather]="icon"></i>
